/** Ride map visual display mode (session-overridable; default from `ridesMapDefaultDisplayMode` system param). */
export enum LiveMapDisplayModeEnum {
  /**
   * Simple display (default): small station dots (last station keeps flag), planned route line kept,
   * no actual GPS tracking path — only the current vehicle position.
   */
  noDrivePath = "noDrivePath",
  /** Full display: numbered station pins, planned + GPS paths, full tracking. */
  stationPins = "stationPins",
}
